export default __webpack_public_path__ + "static/media/GOOD AND BAD TOOLS SIMULATOR.0571c98e.JPG";